import React from 'react'
import { SurfacePalette, type } from '../../tokens'
import { SectionCard } from './SectionCard'

interface Props {
  palette: SurfacePalette
  packetID: number
}

export const AudienceFrameworkPlaceholderSection = ({ palette, packetID }: Props) => (
  <SectionCard
    palette={palette}
    sectionKey="audience-framework"
    title="Audience framework"
    muted
    commentAnchor={{
      type: 'section',
      id: `${packetID}:audience-framework`,
      label: 'Audience framework',
    }}
  >
    <p style={{ margin: 0, fontSize: type.size.body, color: palette.textMuted }}>
      Placeholder for v0. The live primary-funnel detail and secondary-audience cards land in v1.1
      and v1.2.
    </p>
  </SectionCard>
)
